// Xeno Electronics Theme JS

// Mobile nav toggle (if needed)
document.addEventListener('DOMContentLoaded', function() {

  // Update cart count in header
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const el = document.querySelector('.cart-count');
      if (el) el.textContent = cart.item_count;
    });

  // Variant selection highlight
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      const name = this.name;
      document.querySelectorAll(`input[name="${name}"]`).forEach(r => {
        r.nextElementSibling.style.borderColor = '#E2E5EA';
        r.nextElementSibling.style.color = 'inherit';
        r.nextElementSibling.style.background = 'white';
      });
      this.nextElementSibling.style.borderColor = '#0055FF';
      this.nextElementSibling.style.color = '#0055FF';
      this.nextElementSibling.style.background = '#EBF0FF';
    });
  });

});
